export default __webpack_public_path__ + "static/media/illustrativeShop.01e2caf1.svg";